/* eslint-disable */
import React, { Component } from 'react'
import {
  ScrollView, Text,
  StatusBar,
  KeyboardAvoidingView,
  View, TouchableOpacity,
  Image, findNodeHandle,
  Animated,
  Dimensions,
  Platform
} from 'react-native'
import { connect } from 'react-redux'
import { Icon, Item, Input } from 'native-base'

import { Images, Fonts, Colors } from '../Themes'
import BaseScreen from './BaseScreen'
import MainNavBarScreen from './MainNavBarScreen'

//import { BlurView } from 'react-native-blur';
import SearchBarComponent from '../Components/SearchBarComponent'

import ExploraPeople from '../Components/ExploraPeople'
import ExploraDiscover from '../Components/ExploraDiscover'
import ExploraKargoeTags from '../Components/ExploraKargoeTags'
import ExploraShopping from '../Components/ExploraShopping'
import LottieView from 'lottie-react-native'
//import SafariView from '../Lib/SafariView/'

import API from '../Services/Api'
import FixtureAPI from '../Services/FixtureApi'
import { KargoeConfig } from '../Config/AppConfig'
import DebugConfig from '../Config/DebugConfig'


import { RecyclerListView, DataProvider, LayoutProvider } from "recyclerlistview";

import styles from './Styles/ExploraScreenStyle'
import images from '../Themes/Images'



// import GetFollowActions from '../Redux/GetFollowRedux'
import PostsActions from "../Redux/PostsRedux"
import UserPopularActions from "../Redux/UserPopularRedux"
import PostPeopleActions from "../Redux/PostPeopleRedux"
import SwiperActions from '../Redux/SwiperRedux'
import KargoeTagActions from "../Redux/KargoeTagRedux"
import KargoeSearchTagActions from "../Redux/KargoeSearchTagRedux"
import ShoppableActions from "../Redux/ShoppableRedux"
import FollowActions from "../Redux/FollowRedux"
import { isBlank, getUri } from '../Lib/utils'
import Immutable from 'seamless-immutable'
import TextComponent from '../Components/TextComponent'
import I18n from "i18n-js"

import { NavigationActions } from 'react-navigation'

const { width, height } = Dimensions.get("window")
const screenWidth = width
let imageHeight = (width*1/3) * 0.65
if (Platform.OS == 'web' & imageHeight > 80) imageHeight = 80

const itemWidth = (width) / 4
const itemHeight = itemWidth
const doublebold = { fontFamily : Fonts.style.font.bold, fontWeight : 'bold', color : 'black' }
const normalshadow = { shadowColor : '#333', shadowOffset : { width : 0, height : 5 }, shadowRadius : 3, shadowOpacity : 0.5 }
const HEADER_MIN_HEIGHT = 40
const HEADER_MAX_HEIGHT = imageHeight
const ShoppablePopupStyle = { backgroundColor : 'white', borderRadius : 12, borderColor : 'black', borderWidth : 1, padding : 8, zIndex : 3, ...normalshadow }
const ShoppablePopupTextStyle = { ...doublebold, fontSize : 14 }

const isIPhone5 = Math.abs(width - 320) < 0.1 // or 5S / SE small screen

const DownloadImageAverageTime = 1
const AverageOpenDownloadThreads = 5

const theResizeMode = /*Platform.OS == 'web' ? 'contain' :*/ 'cover'

const ActiveTab = props =>
  <TouchableOpacity
      onPress={( ) => props.parent.delegates.changeTabDelegate(props.tab)}
      style={{  flex : 1/4, height : /*width/5*/imageHeight, padding : 2
              , shadowRadius : 2, shadowColor : 'black', shadowOffset : { width : 0, height : 2 }, shadowOpacity : 0.8 }}>
    <View style={{ flexDirection : 'column', justifyContent : 'center', alignItems : 'center', height : '100%' }}>
      <Image source={props.image} style={{ position : 'absolute', top : 0, left : 0, width : '100%' , height : '100%', borderRadius : 12 }} resizeMode={theResizeMode}/>

        <Text  allowFontScaling={false} style={{  position: 'absolute', top: imageHeight/2 - 30/2, width: '100%', height: 30, textAlign : 'center', fontFamily : Fonts.style.font.extraBold, /*fontWeight : '900',*/ color : 'white', fontSize : isIPhone5 ? 11 : 13
                        , textDecorationLine : props.parent.state.activeTab===props.tab?'underline':'none' }}> {
            props.name.toUpperCase( )
        } </Text>
    </View>
  </TouchableOpacity>
const ShoppableTimeout = props =>
    <View style={{ width : '100%', height : '100%', position : 'absolute', top : 0, left : 0 }}>
        <View style={ShoppablePopupStyle}>
          <Text style={ShoppablePopupTextStyle}>Sorry, Shoppable is not available or is not responding at this time, please try again later.</Text>
        </View>
    </View>
const base = [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,57,58,59,60,61,62,63,64,65,66,67,68,69,70,71,72,73,74,75,76,77,78,79,80,81,82,83,84,85,86,87,88,89,90,91,92,93,94,95,96,97,98,99]
class ExploraScreen extends Component {
  make100 = fun => base.reduce(fun, [ ])
  randomColor = ( ) => this.colors[Math.floor(4 * Math.random( ))]
  viewable = i => i < 20
  templatePost = i => ({ viewable : this.viewable(i), tileColor : this.randomColor( ) })
  templatePosts = ( ) => this.make100((li,u,i) => { li.push(this.templatePost(i)) ; return li })
  templatePerson = (UID,i) => ({ FirstName : ' ', LastName : ' ', Online : false, Posts : [ ], State : '1', UserId : UID||'false', UserIsFollowing : false, UserKind : 100, Username : '...', viewable : this.viewable(i), tileColor : this.randomColor( ) })
  samplePerson = (Person,i) => ({ FirstName : Person.FirstName, LastName : Person.LastName, Online : false, Posts : [ ], State : Person.State, UserId : Person.UserId, UserIsFollowing : false, UserKind : Person.UserKind, Username : Person.Username, viewable : this.viewable(i), tileColor : this.randomColor( ) })
  templatePeople = UIDs => {
    let fun = (UIDs && Array.isArray(UIDs) && typeof UIDs[0] === 'object')
                  ? (li,u,i) => { li.push(this.samplePerson(u,i)) ; return li }
                  : (li,u,i) => { li.push(this.templatePerson(u,i)) ; return li }
    return UIDs? UIDs.reduce(fun, [ ]): this.make100(fun)
  }
  templateItem = i =>
      ({  Availability : 1, Brand : '...', Category : '', Codes : [ ], Cut : {Pct:'100.00',Min:'1.00',Max:'1.00'}
        , Description : '...', EndorserPct : '100.00', ExtStoreItemId : '', ImageUrls : [''], ItemId : 'false'
        , NumVariants : 0, Options : 'Default Title', PlatformDeleted : false, PriceMin : 0.00, PriceMax : 100.00//1000000.00
        , SellerKind : 'sk1', State : 1, StoreId : 'false', StoreName : '...', Tags : ['a','bb'], ThumbUrls : ['']
        , Title : '...', Posts : [ ], viewable : this.viewable(i), tileColor : this.randomColor( )
      })
  sampleItem = (Item,i) => Object.assign({ viewable : this.viewable(i), tileColor : this.randomColor( ), Posts : [ ] }, Item)
  templateItems = Items =>
      Items
        ? Items.reduce((li,u,i) => { li.push(this.sampleItem(u,i)) ; return li }, [ ])
        : this.make100((li,u,i) => { li.push(this.templateItem(i)) ; return li })
  constructor(props) {
    super(props);

    this.colors = [ Colors.cellbg1, Colors.cellbg2, Colors.cellbg3, Colors.cellbg4 ]
    this.state = { discoverData : this.templatePosts( ), peopleData : this.templatePeople( ), itemData : this.templateItems( )
      , resetTime : null
      , loadTimes : [ false, 0, 0, 0, 0 ] // [ Date.now( ), ... ] this.state.activeTab
      , activeTab: 2, searchText: '', barcoder: false
      , shoppable : false, refreshing : false
      , configPopupTemplate : <ShoppableTimeout/>
    }
    this.timeout = 0
    this.api = DebugConfig.useFixtures ? FixtureAPI : API.create( )
    this.api.setAuthorization(this.props.token)
    this.refresherHeight = new Animated.Value(0)
    this.tabSearchFunctions = [   false // 0
                                , this.downloadTab.bind(this,'people')
                                , this.downloadTab.bind(this,'discover')
                                , this.downloadTab.bind(this,'kargoetag')
                                , this.downloadTab.bind(this,'shopping')
                              ]
    this.delegates =  { changeTabDelegate : activeTab => {
                          let loadTime = this.state.loadTimes [activeTab]
                            , expireSeconds = 30, timeDelta = 1000
                            , reload = Date.now( ) - loadTime > (expireSeconds*timeDelta)
                          console.log('tab')
                          this.setState({ activeTab : activeTab, barcoder : activeTab === 3?true:false }
                                        , ( ) =>  { //if(reload) {
                                                      console.log('reload')
                                                      this.performSearch( )
                                                      this.state.loadTimes[activeTab] = Date.now( )
                                                      //}
                                        })
                        }
                      }
    this.nextPeoplePage = 0
    this.loadingMore = false
    if (Platform.OS != 'web')
    this.dismissSubscription = SafariView.addEventListener(
                                                             "onDismiss",
                                                             () => {
                                                                StatusBar.setHidden(false)
                                                                StatusBar.setBarStyle("default", true);
                                                             }
                                                          )
  }


  onHomePress = ( ) => {
    // this.props.navigation.goBack( )
    this.props.navigation.dispatch(NavigationActions.reset({
        index: 0,
        key: null,
        actions: [NavigationActions.navigate({ routeName: 'home', params: {} })]
    }))
  }

  finishShoppableConfigSetup = (data) => {
    // console.tron.display({name: 'checkShoppableConfigurationCache', preview: `headers`, value: {headers: data.headers}})
    this.api.shoppableSetHeaders(data.headers)
    this.api.shoppableSetBaseURL(data.baseURI)

    let config = {fetching:false,modified:Date.now( ),error:null,headers:data.headers,data:data}
    console.log('configuring shoppableApi (API.js) headers')
    console.log(config)

    // set Redux state QED
    this.props.setShoppableStateRemotely({ config : config })

    const newData = KargoeConfig.shoppable.active ? data :
      Object.assign({}, data, {
        baseURI: null,
        commitURL: null,
        listQuery: null,
        itemCount: 0,
        categories: [],
        colors: [],
        brands: [],
        merchants: [],
      })
    console.tron.display({name: 'checkShoppableConfigurationCache', preview: `shoppable response`, value: {newData, data}})
    this.setState({ shoppable : newData })
  }

  checkShoppableConfigurationCache = ( ) => {
    if( this.props.shoppable.config ) {
      if( this.props.shoppable.config.data === null || (KargoeConfig.shoppable.active != (this.props.shoppable.config.data.baseURI != null)) ) {
        if( ! this.state.configTimeout ) {
          this.state.configTimeout = setTimeout(( ) => this.state.configPopup = this.state.configPopupTemplate, 15000)
        }
        const cacheData = this.api.cacheGet('shoppableConfig')
        if (cacheData) {
          this.finishShoppableConfigSetup(cacheData)
          return
        }
        this.api.getShoppableConfig ( )
        .then(resp => {
          console.log('fetched shoppable config state from remote')
          if( this.state.configTimeout ) clearTimeout(this.state.configTimeout) && delete this.state.configTimeout
          if( resp.ok ) {
            console.log(resp)
            const data = resp.data.data
            this.finishShoppableConfigSetup(data)
            this.api.cacheSet('shoppableConfig', data, 86400)
          }
        })
        .catch( err => console.warn(JSON.stringify(err)) )
      } else {
        if( this.state.configTimeout ) clearTimeout(this.state.configTimeout) && delete this.state.configTimeout
        console.log('returning shoppable configuration data from state')
        const data = this.props.shoppable.config.data
        this.api.shoppableSetHeaders(data.headers) // cannot fail
        this.api.shoppableSetBaseURL(data.baseURI)
        this.setState({ shoppable : data })
        this.api.cacheSet('shoppableConfig', data, 86400)
      }
    }
  }

  componentDidMount( ) {
    console.log("cdm:  explora this.props.navigation.state.params = " + JSON.stringify(this.props.navigation.state.params))
    this.checkShoppableConfigurationCache()
    this.navigationBar.setRightNavBarButtons([ { onPress: this.onHomePress, type: 'home' } ])
    if (this.props.navigation.state.params && this.props.navigation.state.params.hashTag) {
      this.navigationBar.setLeftNavBarButtons([ { onPress: () => this.props.navigation.goBack(), type: 'back' } ])
      let hashTag = this.props.navigation.state.params.hashTag
      this.setState({ searchText : hashTag }, ( ) => {
        this.exploraSearch.value = hashTag
        this.downloadTab('discover')
      })
    } 
    // scan barcode on main wall, then go here w/ barcoderResult as a string
    else if (this.props.navigation.state.params && this.props.navigation.state.params.barcoderResult) {

      this.setState({ refreshing : true }
        , ( ) => {
          this.delegates.changeTabDelegate(3) // kargoe tags
        })

      setTimeout(function() {
        // this should happen automatically or?
        //this.downloadTab('kargoetag') // go to kargoe tag tab then search for this result
        console.log("ready to search for barcoder result " + this.props.navigation.state.params.barcoderResult)
        this.getKargoeTags(this.props.navigation.state.params.barcoderResult, true)
      }.bind(this), 1000)
    }
    else {
      this.downloadTab ('discover')
      this.navigationBar.setLeftNavBarButtons([ { onPress: this.onHomePress, type: 'back' } ])
    }
  }

  resetWallData = ( ) => {
    console.tron.log(`resetWallData, activeTab: ${this.state.activeTab}`)
    this.setState({ discoverData : this.templatePosts( ), peopleData : this.templatePeople( ), itemData : this.templateItems( ), resetTime : Date.now() })
    return true
  }
  getDiscoverData = search =>
    (search
      ? this.api.searchTagPost({ search })
      : this.api.getLikePost( )
    ).then(resp => resp.ok && this.setState({ discoverData : resp.data.data
                                                .map( (e,i) => Object.assign(this.templatePost(i), e))
                                            , refreshing : false
                                            })
    ).catch(console.warn)

  safariView = (url) => {
        if (true && Platform.OS != 'web') { // url.indexOf('https://secure.shoppable.co') == 0 || isURL(url)) {
            SafariView.openUrl(url)
        } else {
            alertView('Invalid URL', 'url')
        }
  }
  queueStateUpdate = timeout => {
    if(this.updateQueue)
      clearTimeout(this.updateQueue)
    this.updateQueue = setTimeout(( ) => {
      this.updateQueue = false
      this.setState({ update : true })
    }, timeout)
  }
  getExtraPeopleData = async (UIDs, pageOffset = 0, seed) => {
    let values = typeof UIDs[0] === 'string'? UIDs: UIDs.map(e => e.UserId)
      , chunks =  values.reduce((li,u) => {
                    let last = li.length - 1
                    if(!li[last] || li[last].length >= 20) li.push([ u ])
                    else li[last].push( u )
                    return li
                  }, [ ])
    for(var ListOffset = 0, UIDList = chunks[0]; ListOffset < chunks.length; UIDList=chunks[++ListOffset])
      if(seed !== this.extra) return false
      else await this.api.getPostsPeople
                    ({ userIds : UIDList.toString( ), limit : 3 })
                    .then(resp => {
                      for(var i = 0; i < resp.data.data.length; ++i)
                        Object.assign(this.state.people[pageOffset +ListOffset*20 +i], resp.data.data[i])
                      this.state.peopleData = this.state.people
                      this.queueStateUpdate(1000) // don't re-render every single await, do it maximum once per second
                    })
  }
  getInitialPeople = search => {
    // pragma chunkSize = 20
    // [...ASI because line begins with parenthesis]
    this.extra = Math.random( )
    ;(search
      ? this.api.searchUser({ user : search, limit : 100 })
      : this.api.getOrderedUsers( 0 )
    ).then(resp => {
      Animated.timing(this.refresherHeight, { duration : 333, toValue : 0 }).start( )
      if(resp.ok)
        this.setState({ peopleData : (this.state.people = this.templatePeople(resp.data.data)), refreshing : false }
                      , ( ) => {
                          this.getExtraPeopleData(resp.data.data, 0, this.extra)
                          if(!search) this.nextPeoplePage = 100
                        }
                      )
    }).catch(console.warn)
  }
  getMorePeople = ( ) => {
    if( this.state.searchText.length > 0 || this.loadingMore || ! this.nextPeoplePage ) return false
    this.loadingMore = true
    this.api.getOrderedUsers( this.nextPeoplePage )
    .then(resp => {
      if(resp.ok) {
        this.state.people = [...this.state.people, ...this.templatePeople(resp.data.data)]
        this.setState({ peopleData : this.state.people }, ( ) => this.getExtraPeopleData(resp.data.data, this.nextPeoplePage, this.extra))
        this.nextPeoplePage = resp.data.pagination.next || false
      }
      this.loadingMore = false
    }).catch(e => this.loadingMore = false)
  }
  getKargoeTags = async (search, filter) =>
      (search
          ? this.api.getSearchKargoeTag({ search : search, filter : filter?'CODE_LOOKUP':'', limit : 100 })
          : this.api.getKargoeTag({ search : '', filter : '', limit : 100 })
      ).then(resp => {
        if(resp.ok) {
          Animated.timing(this.refresherHeight, { duration : 333, toValue : 0 }).start( )
          this.setState(  { itemData : this.templateItems(resp.data.data), refreshing : false }
                          , async ( ) => {
                              for(var i = 0, item=this.state.itemData[0]; i < this.state.itemData.length; item=this.state.itemData[++i]) {
                                  if(item.viewable) {
                                      item.getting = true
                                      await this.api.getPostByItem(item)
                                            .then(postsResponse => { item.got = true ; item.Posts = postsResponse.data.data })// [ {PostId, SoldCount, TimeStamp}, ... ]
                                  }
                              }
                          })
        }
      })
  
  downloadTab = tab => {
    console.log('download tab')
    let search = this.state.searchText || false
    switch(tab) {
      case 'discover':
        this.getDiscoverData( search )
        break
      case 'people':
        // this.getInitialPeople( search )
        //  this.exploraPeople.scrollView.scrollToOffset({ offset : 0, animated : false })
        break
      case 'kargoetag':
        this.getKargoeTags( search )
        break
      default: break
    }
  }

  performSearch = ( ) => this.resetWallData( ) && this.tabSearchFunctions[ this.state.activeTab ]( )
  onChangeSearch = search =>
    this.setState({ searchText : search }, ( ) => {
      if(typeof search !== 'string' || search.length < 1) return
      if(this.timeout) clearTimeout(this.timeout)
      this.timeout = setTimeout(this.performSearch, 1000)
    })
  onCommitSearch = search =>
    this.setState({ searchText : search }, ( ) => {
      if(this.timeout) clearTimeout(this.timeout)
      this.performSearch( )
    })
  idleSignal = ( ) => {
    console.log('program entered idle loading state')
  }
  resetIdleTimeout = hit => { // hit is how many became viewable which before were not
    if(hit === 0) return this.idleSignal( )
    let scalar = hit / AverageOpenDownloadThreads
      , T = scalar * DownloadImageAverageTime
    if(this.idleTimeout) {
      clearTimeout(this.idleTimeout)
      this.idleTimeout = null
    } setTimeout(this.idleSignal, T)
  }

  onAvatarPress = data => {
    console.tron.display({ name: 'ExploraScreen', preview: 'onAvatarPress', value: { data } })
    if (data.UserId === this.props.auth.user.UserId)
      this.props.navigation.navigate('profile', { userId : this.props.auth.user.UserId })
    else
      this.props.navigation.navigate('postDetail', { userId : data.UserId, username : data.Username })
  }

  componentWillReceiveProps(nextProps) {
    // check for shoppableCheckout or will red screen / crash if shoppableCheckout not defined (noted in crashlytics)
    if (this.props.shoppableCheckout && nextProps.shoppableCheckout) {
        if (this.props.shoppableCheckout.modified != nextProps.shoppableCheckout.modified && nextProps.shoppableCheckout.url !== null)
            this.safariView(nextProps.shoppableCheckout.url)
            }
  }

  componentWillUnmount() {
    console.log('***** explora screen will unmount')

    //SafariView.removeEventListener("onDismiss", this.dismissSubscription)

    if (this.dismissSubscription)
      this.dismissSubscription.remove()

    console.log('did remove safari view event subscription')


    if (this.idleTimeout) { 
      console.log("lingering idle timeout = " + this.idleTimeout + " clear it")
      clearTimeout(this.idleTimeout)
    }

    if (this.updateQueue) {
       console.log("lingering update queue timeout = " + this.updateQueue + " clear it")
       clearTimeout(this.updateQueue)
    }

    if (this.state.configTimeout ) {
      console.log("lingering config timeout = " + this.state.configTimeout + " clear it")
      clearTimeout(this.state.configTimeout) 
      delete this.state.configTimeout
    }
    console.log('***** done with explora screen will unmount')
  }
  onPressFollow = (data, index) => {
    (this.state.peopleData[index].UserIsFollowing? this.props.unFollowUser: this.props.followUser)
        (this.props.auth.user.UserId, this.state.peopleData[index].UserId)
    this.state.peopleData[index].UserIsFollowing = !this.state.peopleData[index].UserIsFollowing
    this.setState({ redraw : true })
  }
  goToPost = (PostId,UserId,Username) => this.props.navigation.navigate('profile', {postId : PostId, userId  : UserId, username  : Username })
  onPressPeople = (item,data) => this.goToPost(item.PostId,item.UserId,data.Username)
  gotoDescription = (item) => this.props.navigation.navigate('product', { item })

  refreshEvent = this.performSearch

  viewAllPosts = (data, item) => this.props.navigation.navigate("exploraViewPostV2", { data })
  onPressPost = (data, index) => this.props.navigation.navigate("exploraViewPostV2", { data, index })
  onPressEndorse = (data) => {
    if (Platform.OS != 'web') {
    console.tron.log(`onPressEndorse`, data)
    this.props.changeIndex({ indexChange : 0, ktagCallerInfo : data })
    } else {
      alert("To endorse products and get paid, try our mobile app Kargoe for iPhone and Android!  In your app store now!")
    }
  }
  discoverPost = (item, index) => this.props.navigation.navigate('discoverDetailV2', { data: this.state.discoverData, PostId: item.PostId, index })

  getBarcoder = ({barcoder}) => barcoder? this.getKargoeTags(barcoder, true): false
  onPressBarcoder = ( ) => this.props.navigation.navigate('barCoder', { getBarcoder: this.getBarcoder })

  clearButtonClick = ( ) => {
    this.exploraSearch.value = ''
    this.setState({ searchText : '' }, this.refreshEvent)
  }
  onRefresh = tab => {
    Animated.timing(this.refresherHeight, { duration : 333, toValue : 100 }).start( )
    this.setState({ refreshing : true }
      , ( ) => {
        this.delegates.changeTabDelegate(tab)
      })
  }
  empty = props =>
    <View style={{ width : width, flex : 1, flexDirection : 'column', justifyContent : 'center', alignItems : 'center' }}>
      <Text style={{ color : '#ccc', fontWeight : 'bold', fontFamily : Fonts.style.font.regular, fontSize : 30, lineHeight : 50, height : 50 }}>Sorry No Results</Text>
      <Image source={Images.sorryNoResults} resizeMode='contain' style={{ marginLeft: 0, marginTop: 0, width : width * (1/3), height : 200 }}/>
    </View>
  render( ) {
    return (
      <BaseScreen>
        <MainNavBarScreen title={I18n.t('explora.title')} ref={view => this.navigationBar = view}/>

        <View bounces={false} style={[styles.container, { backgroundColor: 'transparent' }]}
              contentContainerStyle={styles.container}>

          {this.state.activeTab === 4
              ? <View style={styles.main}>
                        <View style={{ flexDirection : 'row', height : HEADER_MAX_HEIGHT }}>
                            <ActiveTab name={/*I18n.t('explora.people')*/'people'} parent={this} tab={1} image={images.v2ExploraPeople} />
                            <ActiveTab name={/*I18n.t('explora.discover')*/'discover'} parent={this} tab={2} image={images.v2ExploraDiscover} />
                            <ActiveTab name={/*I18n.t('explora.kargoetag')*/'kargoetag'} parent={this} tab={3} image={images.v2ExploraKargoetag} />
                            <ActiveTab name={/*I18n.t('explora.shopping')*/'shopping'} parent={this} tab={4} image={images.v2ExploraShopping} />
                        </View>

                        { this.state.shoppable
                            ? <ExploraShopping resetTime={this.state.resetTime} endorseIt={this.onPressEndorse} dataProvider={this.state.shoppable} api={this.api} navigation={this.props.navigation} shoppable={this.props.shoppable}/>
                            : <View style={{ backgroundColor : 'white', width : '100%', height : '100%', flex : 1 }}>
                                  <View style={{  minWidth: width*0.315, minHeight: width*0.315, maxWidth: width*0.315, maxHeight: width*0.315
                                                , justifyContent : 'center', alignItems : 'center', position : 'absolute', left : width*0.3425, top : 100 }}>

                                        <LottieView style={{ minWidth: width*0.1825, minHeight: width*0.1825, maxWidth: width*0.1825, maxHeight: width*0.1825, marginLeft : -20, marginTop : -30 }}
                                          ref={ spinner => {  if(spinner) {
                                                                this.refs.spinner = spinner
                                                                spinner.play( )
                                                              }}}
                                          loop autoPlay source={Images.spinnerDark}/>

                                          {this.state.configPopup? this.state.configPopup: <View/>}
                                       </View>
                              </View>
                          }
                </View>
              : <Animated.View style={[styles.main]}>

                      <Animated.View style={[styles.animatedHeader, { height: HEADER_MAX_HEIGHT}]}>
                        <View style={[styles.tabContainer]}>

                          <ActiveTab name={/*I18n.t('explora.people')*/'people'} parent={this} tab={1} image={images.v2ExploraPeople} />
                          <ActiveTab name={/*I18n.t('explora.discover')*/'discover'} parent={this} tab={2} image={images.v2ExploraDiscover} />
                          <ActiveTab name={/*I18n.t('explora.kargoetag')*/'kargoetag'} parent={this} tab={3} image={images.v2ExploraKargoetag} />
                          <ActiveTab name={/*I18n.t('explora.shopping')*/'shopping'} parent={this} tab={4} image={images.v2ExploraShopping} />

                        </View>
                      </Animated.View>
                      <SearchBarComponent
                        clearButton={true}
                        placeholder={I18n.t("explora.search") + " ..."}
                        ref={ref => this.exploraSearch = ref}
                        onPressBarcoder={this.onPressBarcoder}
                        barcoder={this.state.barcoder}
                        clearButtonClick={this.clearButtonClick}
                        fetching={this.props.fetching}
                        initialValue={this.state.searchText}
                        value={this.state.searchText}
                        onChangeText={this.onChangeSearch} onSubmitEditing={this.onCommitSearch} />
                      {/*<Animated.Image style={{ width: width, height: this.refresherHeight }} source={images.refreshControl}/>*/}
                      <View style={{ backgroundColor : 'white', position : 'absolute', zIndex : -1, top : 0, left : 0, bottom : 0, right : 0 }}></View>
                      {this.state.activeTab === 1 && <ExploraPeople search={this.state.searchText} follow={this.props.follow} postPeople={this.props.postPeople} getUsers={this.props.getUsers} getUsersAndPosts={this.props.getUsersAndPosts} auth={this.props.auth} followUser={this.props.followUser} unfollowUser={this.props.unFollowUser} data={this.state.peopleData} more={this.getMorePeople} empty={this.empty} onRefresh={( ) => this.onRefresh(1)} refreshing={this.state.refreshing} ref={ref=>this.exploraPeople=ref} onAvatarPress={this.onAvatarPress} onPressPost={this.onPressPeople} onPressRightIcon={this.onPressFollow} resetIdleTimeout={this.resetIdleTimeout}/>}
                      {this.state.activeTab === 2 && <ExploraDiscover data={this.state.discoverData} viewMode={'grid'} empty={this.empty} onRefresh={( ) => this.onRefresh(2)} refreshing={this.state.refreshing} onPressItem={this.discoverPost} resetIdleTimeout={this.resetIdleTimeout}/>}
                      {this.state.activeTab === 3 && <ExploraKargoeTags data={this.state.itemData} empty={this.empty} onRefresh={( ) => this.onRefresh(3)} refreshing={this.state.refreshing} onLeftPress={this.gotoDescription} onPressRightIcon={this.onPressEndorse} viewAllPosts={this.viewAllPosts} onPressPost={this.onPressPost} getItemPosts={this.api.getPostByItem} resetIdleTimeout={this.resetIdleTimeout}/>}

                </Animated.View>
          }
        </View>
      </BaseScreen>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    // folllowers: [], // state.getFollow,
    follow: state.follow,
    auth: state.auth,
    userPosts: state.postPeople.userPosts,
    fetching: state.postPeople.fetching,
    postPeople: state.postPeople,
    kargoeTags: state.kargoeTag.kargoeTags,
    discovers: state.posts.posts,
    token : state.auth.token,
    shoppable: state.shoppable,
    shoppableCheckout: state.shoppable ? state.shoppable.checkout : false,
    transparentPanels: false
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    // getFollow: (userId, isFollower) => dispatch(GetFollowActions.getFollowRequest(userId, isFollower)),
    followUser: (userId, user2Id) => dispatch(FollowActions.followRequest(userId, user2Id)),
    unFollowUser: (userId, user2Id) => dispatch(FollowActions.unfollowRequest(userId, user2Id)),
    // getUsers: data => dispatch(UserPopularActions.userPopularRequest(data)),
    getUserAndPost: data => dispatch(PostPeopleActions.postPeopleRequest(data)),
    getUsers: search => dispatch(PostPeopleActions.postPeopleRequest2(search)),
    getUsersAndPosts: userIds => dispatch(PostPeopleActions.postPeoplePostRequest(userIds)),
    getKargoeTag: data => dispatch(KargoeTagActions.kargoeTagRequest(data)),
    getSearchTag: data => dispatch(KargoeTagActions.kargoeTagSearchRequest(data)),
    getDiscover: post => dispatch(PostsActions.postsLikeRequest(post)),
    searchDiscover: post => dispatch(PostsActions.postsTagRequest(post)),
    changeIndex: (index) => dispatch(SwiperActions.changeIndex(index)),
    shoppableGetConfig: () => dispatch(ShoppableActions.shopGetConfig()),
    setShoppableStateRemotely: nextState => dispatch(ShoppableActions.shopStateChange(nextState))
  //,
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ExploraScreen)
